import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDZekLZqS-2wDdmOKrfWY6hI5u-Eh3s-jM",
  authDomain: "chairs-c5451.firebaseapp.com",
  projectId: "chairs-c5451",
  storageBucket: "chairs-c5451.appspot.com",
  messagingSenderId: "1038688752702",
  appId: "1:1038688752702:web:73d794c7b0f9a685536d6f",
  measurementId: "G-39BFZ807JP",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);
